import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { OrganizationSetupCommon } from './../organization-setup.common';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { CommonMessageService } from 'src/app/services/common-message.service';

@Component({
  selector: 'app-branch-holidays',
  templateUrl: './branch-holidays.component.html',
  styleUrls: ['./branch-holidays.component.css']
})
export class BranchHolidaysComponent implements OnInit {
  selectedBranch = null;
  branchList: any;
  branchHolidayList: any;
  selectedFY = null;
  financialYearList: any;

  modalFormObjList: any;
  modalForm: any;
  modalStatus: any;
  formSubmitted = false;
  formErrors = OrganizationSetupCommon.holidayFormErrors;
  formValidationMessages = OrganizationSetupCommon.holidayFormValidationMessages;

  constructor(private organizationSetupService: OrganizationSetupService,
    private masterDataService: MasterDataService,
    private fb: FormBuilder, private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadBranch();
    this.modalForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.modalForm);
    });
  }

  loadBranch() {
    this.masterDataService.getBranch()
      .subscribe(res => {
        console.log(res);
        this.branchList = res;
        // const branchIndex = this.branchList.findIndex(item => item.id == 1);

        var branchIndex = -1;
        this.branchList.forEach((element, key) => {
          if (element.name == 'Pune') {
            branchIndex = key;
          }
        });
        this.selectedBranch = this.branchList[branchIndex];
        console.log("intit branch", this.branchList[branchIndex])
        this.modalForm.patchValue({
          branch: this.branchList[branchIndex],
        });
        this.selectedBranch = this.branchList[branchIndex]
        this.loadFinancailYear();
      });

  }

  loadFinancailYear() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        console.log("years :", res);
        this.financialYearList = res;
        var fyIndex = -1;
        this.financialYearList.forEach((element, key) => {
          var startDate = new Date(element.startDate);
          var endDate = new Date(element.endDate);
          // var currentDate = new Date();
          var currentDate = moment(new Date()).format("YYYY-MM-DD");
          console.log(startDate, endDate);;
          console.log(currentDate + " " + element.startDate + " " + element.endDate);
          // if(currentDate>=startDate && currentDate<=endDate){
          //   fyIndex = key;
          // }
          if (currentDate >= element.startDate && currentDate <= element.endDate) {
            fyIndex = key;
          }
          console.log("fyIndex", fyIndex)
        });
        console.log("financialYearList[fyIndex]", this.financialYearList[fyIndex])
        this.selectedFY = this.financialYearList[fyIndex];
        console.log("this.selectedFY", this.selectedFY)
        this.getHoildayList()
      });

  }


  // Form
  initModalForm() {
    this.modalForm = this.fb.group({
      id: [''],
      branch: ['', [Validators.required]],
      holidayDate: ['', [Validators.required]],
      holidayDescription: ['', [Validators.required]],
    });
  }



  loadBranchHolidays() {
    const branchIndex = this.branchList.findIndex(item => item.id == this.selectedBranch.id);
    this.modalForm.patchValue({
      branch: this.branchList[branchIndex],
    });

  }

  getHoildayList() {
    console.log("this.selectedBranch.id", this.selectedBranch.id);
    console.log("this.selectedBranch.id", this.selectedFY.id);
    if (this.selectedBranch == 'Select' || this.selectedFY == 'Select') {
      this.commonMessageService.swalAlertWithoutIcon('','Please select both the fields')
    } else {
      this.organizationSetupService.getBranchHolidays(this.selectedBranch.id, this.selectedFY.id)
        .subscribe(res => {
          console.log(res);
          this.modalFormObjList = res;
          console.log("this.modalFormObjList", this.modalFormObjList)
        });
    }
  }

  // Modal Code
  openModal(content, status) {
    this.modalStatus = status;
    if (!(this.modalStatus == 'edit')) {
      // this.resetModalForm();
    }
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
    this.resetModalForm();
  }

  resetModalForm() {
    this.formSubmitted = false;
    this.modalForm.reset();
  }
  //

  // ----------------------------
  getValueFromModalForm() {
    var holidayDate = new Date(this.modalForm.value.holidayDate.year + '-' + this.modalForm.value.holidayDate.month + '-' + this.modalForm.value.holidayDate.day);
    var data = {
      id: this.modalForm.value.id,
      branch: this.modalForm.value.branch,
      holidayDate: moment(holidayDate).format("YYYY-MM-DD"),
      holidayDescription: this.modalForm.value.holidayDescription,
    }
    var jsonValue = JSON.stringify(data);
    console.log(jsonValue)
    return jsonValue;
  }

  setValueToModalForm(modalObj) {
    console.log(modalObj);
    var holidayDate = new Date(modalObj.holidayDate);
    var holidayDate1 = moment(holidayDate, 'YYYY/MM/DD');
    const branchIndex = this.branchList.findIndex(item => item.id == this.selectedBranch.id);
    this.modalForm.patchValue({
      id: modalObj.id,
      branch: this.branchList[branchIndex],
      holidayDescription: modalObj.holidayDescription,
      holidayDate: { year: parseInt(holidayDate1.format('YYYY')), month: parseInt(holidayDate1.format('M')), day: parseInt(holidayDate1.format('D')) },
    });
    console.log(this.modalForm.value)
  }

  //----------------------
  disableEditAndDelete(date) {
    var tempDate = new Date(date);
    if (tempDate.getDay() == 6 || tempDate.getDay() == 0) {
      return true;
    }
    return false;
  }

  onDeleteClick(item) {
    console.log(item);
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
         this.modalStatus = 'delete';
          this.organizationSetupService.deleteBranchHoliday(item)
          .subscribe(resp => {
           console.log(resp);
           this.changeModalFormObjList(item);
        this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
      })
      }
    })
  }

  onSaveClick() {
    console.log(this.modalForm);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.organizationSetupService.saveBranchHoliday(this.getValueFromModalForm())
        .subscribe(resp => {
          console.log(resp);
          this.closeModal();
          this.changeModalFormObjList(resp);
          this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
        })
    }
  }

  viewModalFormObj(formObj, content) {
    this.organizationSetupService.viewBranchHoliday(formObj.id)
      .subscribe(resp => {
        this.setValueToModalForm(resp);
        this.openModal(content, 'edit');
      })
  }

  onEditClick(modalContent, formObj) {
    console.log(formObj);
    // this.viewModalFormObj(formObj,modalContent);
    this.setValueToModalForm(formObj);
    this.openModal(modalContent, 'edit');
  }

  onUpdateClick() {
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    if (this.modalForm.valid) {
      this.organizationSetupService.updateBranchHoliday(this.getValueFromModalForm())
        .subscribe(resp => {
          console.log(resp);
          this.changeModalFormObjList(resp);
          this.closeModal();
          this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
        })
    }
  }

  //Setting
  changeModalFormObjList(modalFormObj) {
    if (this.modalStatus == 'add') {
      this.modalFormObjList.push(modalFormObj);
    }
    if (this.modalStatus == 'edit') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1, modalFormObj);
    }
    if (this.modalStatus == 'delete') {
      var index = this.modalFormObjList.findIndex(item => item.id === modalFormObj.id)
      this.modalFormObjList.splice(index, 1);
    }
  }



  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

}
